enum OrderingPriority {
  Campaign = 1,
  Switching = 2,
  CrossSale = 3,
  TLASpecial = 4
}

export default OrderingPriority;
